import Card from "@/shared/data-display/card";
import Tabs from "@/shared/data-display/tabs";
import Page from "@/shared/page";
import { ReactNode } from "react";
import { useTranslations } from "use-intl";

export function BpmProcessEditorGrid({
  routeForm,
  initiatorNotificationTemplate,
  approverNotificationTemplate,
  processInfo,
}: {
  routeForm: ReactNode;
  initiatorNotificationTemplate: ReactNode;
  approverNotificationTemplate: ReactNode;
  processInfo?: ReactNode;
}) {
  const t = useTranslations("BpmProcessEditorGrid");
  const tabs = [];

  if (processInfo) {
    tabs.push({
      key: "processInfo",
      label: t("Process info"),
      forceRender: true,
      children: processInfo,
    });
  }

  tabs.push(
    ...[
      {
        key: "route",
        label: t("Route"),
        forceRender: true,
        children: routeForm,
      },
      {
        key: "templates",
        label: t("Templates"),
        forceRender: true,
        children: (
          <div className="mb-6">
            <Page.Grid>
              <Card title={t("Initiator notification template")}>
                {initiatorNotificationTemplate}
              </Card>

              <Card title={t("Approver notification template")}>
                {approverNotificationTemplate}
              </Card>
            </Page.Grid>
          </div>
        ),
      },
    ],
  );

  return <Tabs items={tabs} />;
}
